import Box from '@mui/material/Box';
import type { ReactNode } from 'react';

interface DeltaProps {
  value: number;
  suffix?: string;
  invert?: boolean;
  fontSize?: number;
}

export function Delta({
  value,
  suffix = '%',
  invert = false,
  fontSize = 10,
}: DeltaProps): ReactNode {
  const positive = value >= 0;
  const good = invert ? !positive : positive;
  return (
    <Box
      component="span"
      sx={{
        fontSize,
        fontWeight: 700,
        borderRadius: 1,
        py: 0.5,
        px: 1,
        whiteSpace: 'nowrap',
        color: good ? 'success.main' : 'error.dark',
        bgcolor: good ? 'score.high.bg' : 'score.low.bg',
      }}
    >
      {`${positive ? '+' : ''}${value}${suffix}`}
    </Box>
  );
}
